import {
  createAction,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  props as actionProps
} from '@ngrx/store';
import {AuditLog, AuditLogFilter, AuditLogType, SegmentAuditLog} from './audit-logs.service';
import {Page} from '../components/common-interfaces';

export interface AuditLogState {
  auditLogs: Page<AuditLog>,
  segmentAuditLogs: SegmentAuditLog[]
}

export const initialState: Readonly<AuditLogState> = {
  auditLogs: {content: []},
  segmentAuditLogs: []
};
export const auditLogsFeatureKey = 'auditLogsSlice';

export const auditLogFeatureSelector = createFeatureSelector<AuditLogState>(auditLogsFeatureKey);
export const selectAuditLogs = createSelector(
  auditLogFeatureSelector,
  (state) => state.auditLogs
);
export const selectSegmentAuditLogs = createSelector(
  auditLogFeatureSelector,
  (state) => state.segmentAuditLogs
);

export const loadAuditLogs = createAction(
  '[AuditLogs] Load audit logs',
  actionProps<{ auditLogType: AuditLogType, filter: AuditLogFilter }>()
);

export const auditLogsLoaded = createAction(
  '[AuditLogs] Audit logs loaded',
  actionProps<{ auditLogs: Page<AuditLog> }>()
);

export const loadSegmentAuditLogs = createAction(
  '[SegmentAuditLogs] Load segment audit logs'
);

export const segmentAuditLogsLoaded = createAction(
  '[SegmentAuditLogs] Segment audit logs loaded',
  actionProps<{ segmentAuditLogs: SegmentAuditLog[] }>()
);

export const auditLogsReducer = createReducer(
  initialState,
  on(auditLogsLoaded, (state, {auditLogs}) => {
    return {
      ...state,
      auditLogs
    };
  }),
  on(segmentAuditLogsLoaded, (state, {segmentAuditLogs}) => {
    return {
      ...state,
      segmentAuditLogs
    };
  })
);
